// 主题配置
export const theme = {
  token: {
    colorPrimary: '#1ED6FF',
    colorBgContainer: '#141414',
    colorText: '#ffffff',
    colorBgElevated: '#1f1f1f',
    borderRadius: 12,
  },
};

// API 路径
export const API_PATHS = {
  UPLOAD_DOCUMENT: '/api/documents/upload',
  GET_QUESTIONS: '/api/exam/questions',
  SUBMIT_EXAM: '/api/exam/submit',
};

// 路由配置
export const ROUTES = {
  HOME: '/',
  // 学习模块
  STUDY: {
    ROOT: '/study',
    BOOK: (code) => `/study/book/${code}`
  },
  // 题库模块
  TIKU: {
    ROOT: '/tiku',
    CATEGORY: (category, subCategory) => `/tiku/${category}/${subCategory}`
  },
  // 考试模块
  EXAM: {
    ROOT: '/exam',
    PRACTICE: (category, examData) => `/exam/practice/${category}/${examData}`
  },
  // 分类管理
  CATEGORY: '/cate',
  // 用户中心
  USER: '/user',
  // 错题本
  WRONG_QUESTIONS: {
    ROOT: '/wrong-questions',
    DETAIL: (id) => `/wrong-questions/${id}`
  },
  PRICE: '/price',
};